<template>  

    <div class="ibox">

        <h2>Pagamento para o SeuPerito</h2>
        <p>Para prosseguir com a execução pelo perito selecionado, efetue o pagamento do valor de <strong>R$ {{ parseFloat(bid.approved_proposal.amount).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</strong>, que foi negociado com o perito <strong>{{ bid.approved_proposal.expert.user.cropped_name }}</strong></p>

        <div class="ibox-content">

            <h3>Dados da Negociação</h3>
            <br>
            <p><strong>Valor negociado:</strong> R$ {{ parseFloat(bid.approved_proposal.amount).toLocaleString('pt-BR', {minimumFractionDigits: 2}) }}</p>
            <p><strong>Data de entrega:</strong> {{ moment(bid.approved_proposal.final_date).format('DD/MM/YYYY hh:mm') }}</p>
            <p><strong>Proposta aprovada em:</strong> {{ moment(bid.approved_proposal.proposal_approved_at).format('DD/MM/YYYY hh:mm') }}</p>
            
            <p><strong>Escopo</strong></p>
            
            <div class="ibox-content">
                <p>{{ bid.approved_proposal.scope }}</p>
            </div>
            
            <br>

            <p><strong>Observações</strong></p>
            
            <div class="ibox-content">
                <p>{{ bid.approved_proposal.comments }}</p>
            </div>

        </div>

        <span v-if="!bid.bid_transaction || bid.bid_transaction.status == 7 || bid.bid_transaction.status == 6">

            <!-- Passo 1 -->
            <div class="ibox-content payments-method">
                <div>
                    <p class="no-margins">
                        <strong>1º passo:</strong> Escolha a forma de pagamento
                    </p>
                </div>
                <div class="row" v-if="activeStep === 'one'">

                    <form name="formPaymentMethod" id="formPaymentMethod">
                        <ul class="paymentMethods">
                            <li>
                                <input type="radio"
                                    :value="'boleto'"
                                    v-model="selectedPaymentMethod"
                                    :id="'paymentMethod-1'">
                                <label class="pacote" :for="'paymentMethod-1'">
                                    <h2>Boleto</h2>
                                </label>
                            </li>
                            <li>
                                <input type="radio"
                                    :value="'creditCard'"
                                    v-model="selectedPaymentMethod"
                                    :id="'paymentMethod-2'">
                                <label class="pacote" :for="'paymentMethod-2'">
                                    <h2>Cartão de Crédito</h2>
                                </label>
                            </li>
                            <li>
                                <input type="radio"
                                    :value="'pix'"
                                    v-model="selectedPaymentMethod"
                                    :id="'paymentMethod-3'">
                                <label class="pacote" :for="'paymentMethod-3'">
                                    <h2>Pix</h2>
                                </label>
                            </li>
                        </ul> 
                    </form>

                    <button :disabled="!selectedPaymentMethod" class="btn btn-md btn-primary" @click="goToStep('two')">
                        Próximo
                    </button>

                </div>
            </div>

            <!-- Passo 2 -->
            <div class="ibox-content checkout">

                <div>
                    <p class="no-margins" v-if="!selectedPaymentMethod">
                        <strong>2º passo:</strong> Selecione um Metodo de Pagamento
                    </p>
                    <p class="no-margins" v-if="selectedPaymentMethod == 'creditCard'">
                        <strong>2º passo:</strong> Insira os dados do cartão
                    </p>
                    <p class="no-margins" v-else-if="selectedPaymentMethod == 'boleto'">
                        <strong>2º passo:</strong> Informaçoes importantes para compra no boleto
                    </p>
                    <p class="no-margins" v-else-if="selectedPaymentMethod == 'pix'">
                        <strong>2º passo:</strong> Informaçoes importantes para compra no pix
                    </p>
                </div>

                <div class="row" v-if="activeStep === 'two'">
                    <div>

                        <div class="row" v-if="selectedPaymentMethod == 'boleto'">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-lg-12">
                                        <br><br>
                                        As compras no boleto podem levar até 72 horas para compensação, pois depende do processo bancário.<br><br>
                                        Você receberá no seu email cadastrado o link para impressão do boleto caso não queira imprimir agora.<br><br> 
                                        <br><br>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div class="row" v-if="selectedPaymentMethod == 'pix'">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="col-lg-12">
                                        <br><br>
                                            Você receberá no seu email cadastrado o link para pagamento caso não queira pagar agora.<br><br>
                                        <br><br>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div class="row" v-if="selectedPaymentMethod == 'creditCard'">
                            <div class="col-md-12">

                                <div class="form-group col-md-12" :class="{ 'has-error': false }">
                                    <label for="" class="control-label">Nome escrito no cartão *</label>
                                    <input type="text" class="form-control" maxlength="50" :class="{ 'has-error': nameError }" v-model="cardName" placeholder="Digite da forma que está no cartão">
                                    <span class="help-block" v-if="nameError">
                                        {{ nameError }}
                                    </span>
                                </div>

                                <div class="form-group col-md-12" :class="{ 'has-error': false }">
                                    <label for="" class="control-label">CPF do Titular do Cartão *</label>
                                    <input type="text" class="form-control" :class="{ 'has-error': documentCardError }" placeholder="Somente números" maxlength="11" v-model="documentCard">
                                    <span class="help-block" v-if="documentCardError">
                                        {{ documentCardError }}
                                    </span>
                                </div>

                                <div class="form-group col-md-6" :class="{ 'has-error': false }">
                                    <label for="" class="control-label">Data de Nascimento *</label>
                                    <input type="date" class="form-control" :class="{ 'has-error': birthDateError }" v-model="birthDate">
                                    <span class="help-block" v-if="birthDateError">
                                        {{ birthDateError }}
                                    </span>
                                </div>

                                <div class="">

                                    <div class="col-md-7">
                                        <div class="form-group"
                                            :class="{ 'has-error': paymentCardBrandError }">
                                            <label for="paymentCardBrand" class="control-label">Bandeira *</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <select class="form-control"
                                                            id="paymentCardBrand"
                                                            v-model="paymentCardBrand"
                                                            required
                                                    >
                                                    <option v-for="brand in cardBrands"
                                                            :value="brand.code"
                                                            :key="brand.code"
                                                            v-text="brand.name"
                                                    ></option>
                                                    </select>
                                                </div>                                            
                                            </div>
                                            <span class="help-block" v-if="paymentCardBrandError">
                                                {{ paymentCardBrandError }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-7">
                                        <div class="form-group" :class="{ 'has-error': cardNumberError }">
                                            <label for="cardNumber" class="control-label">Nº do Cartão *</label>
                                            <input type="text" class="form-control" v-model="cardNumber" id="cardNumber" placeholder="Somente números">
                                            <span class="help-block" v-if="cardNumberError">
                                                {{ cardNumberError }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-5 col-lg-6">
                                        <div class="form-group" :class="{ 'has-error': cvvError }">
                                            <label for="cvv" class="control-label">
                                                Código de Segurança - CVC *
                                                <span data-balloon="Código de 3 dígitos no verso do cartão" data-balloon-pos="up">
                                                    <span class="fa fa-question-circle"></span>
                                                </span>
                                            </label>
                                            <input type="text" class="form-control" v-model="cvv" id="cvv" maxlength="4">
                                            <span class="help-block" v-if="cvvError">
                                                {{ cvvError }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group" :class="{ 'has-error': expirationDateError }">
                                            <label for="expirationDate" class="control-label">Validade (mês / ano) *</label>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <select class="form-control" id="expirationMonth" v-model="expirationMonth">
                                                        <option v-for="month in months" :value="month" :key="month" v-text="month"></option>
                                                    </select>
                                                </div>
                                                <div class="col-md-6">
                                                    <select class="form-control" id="expirationMonth" v-model="expirationYear">
                                                        <option v-for="year in years" :value="year" :key="year" v-text="year"></option>
                                                    </select>
                                                </div>
                                            </div>
                                            <span class="help-block" v-if="expirationDateError">
                                                {{ expirationDateError }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-6" :class="{ 'has-error': false }">
                                        <label for="" class="control-label">Parcelas *</label>
                                        <select name="installments" class="form-control" :class="{ 'has-error': installmentsError }" v-model="installmentCard">
                                            <option v-for="installment in installments" v-bind:value="installment">{{ installment.quantity }}x {{ installment.installmentAmount }}</option>
                                        </select>
                                        <span class="help-block" v-if="installmentsError">
                                            {{ installmentsError }}
                                        </span>
                                    </div>
                                        
                                </div>

                            </div>
                        </div>

                        <div v-if="selectedPaymentMethod == 'pix'">
                            <div class="form-group col-md-12" :class="{ 'has-error': false } ">
                                <label for="" class="control-label">CPF/CNPJ(Somente números)*</label>
                                <input type="text" class="form-control" :class="{ 'has-error': documentCardError }" placeholder="Somente números" maxlength="14" v-model="documentCard">
                                <span class="help-block" v-if="documentCardError">
                                    {{ documentCardError }}
                                </span>
                            </div>
                        </div>

                        <div v-if="selectedPaymentMethod == 'boleto'">
                            <div class="form-group col-md-12" :class="{ 'has-error': false } ">
                                <label for="" class="control-label">CPF/CNPJ(Somente números)*</label>
                                <input type="text" class="form-control" :class="{ 'has-error': documentCardError }" placeholder="Somente números" maxlength="14" v-model="documentCard">
                                <span class="help-block" v-if="documentCardError">
                                    {{ documentCardError }}
                                </span>
                            </div>
                        </div>

                        <div class="form-group col-md-6" :class="{ 'has-error': false }">
                            
                            <label for="" class="control-label">
                                Celular *
                                <span data-balloon="Número delular deve ter 11 dígitos, incluindo o DDD Ex. 11999999999" data-balloon-pos="up">
                                    <span class="fa fa-question-circle"></span>
                                </span>
                            </label>

                            <input type="text" class="form-control" :class="{ 'has-error': cellPhoneError }" placeholder="Somente números" maxlength="11" minlength="11" v-model="cellPhone">
                            <span class="help-block" v-if="cellPhoneError">
                                {{ cellPhoneError }}
                            </span>
                        </div>

                        <div class="form-group">

                            <div class="col-lg-12">
                                <label class="control-label"><strong>Endereço</strong></label>
                            </div>

                            <div class="form-group col-md-3" :class="{ 'has-error': false }">
                                <label for="" class="control-label">CEP *</label>
                                <input type="text" class="form-control" :class="{ 'has-error': postalCodeCardError }" v-model="postalCodeCard" placeholder="Somente números" maxlength="8" @blur="validatePostalCode()">
                                <img src='/img/loader.gif' width="24" v-show="isLoadingCEP" style="position: absolute; right: 15px; top: 30px;" />
                                <span class="help-block" v-if="postalCodeCardError">
                                    {{ postalCodeCardError }}
                                </span>
                            </div>

                            <div class="form-group col-md-7" :class="{ 'has-error': false }">
                                <label for="" class="control-label">Endereço: Ex. Rua,Av.,Tv *</label>
                                <input type="text" class="form-control" :class="{ 'has-error': addressCardError }" maxlength="40" v-model="addressCard">
                                <span class="help-block" v-if="addressCardError">
                                    {{ addressCardError }}
                                </span>
                            </div>

                            <div class="form-group col-md-2" :class="{ 'has-error': false }">
                                <label for="" class="control-label">Núm. *</label>
                                <input type="text" ref="numberAddressCardError" class="form-control" :class="{ 'has-error': numberAddressCardError }" maxlength="20" v-model="numberAddressCard">
                                <span class="help-block" v-if="numberAddressCardError">
                                    {{ numberAddressCardError }}
                                </span>
                            </div>

                            <div class="form-group col-md-5" :class="{ 'has-error': false }">
                                <label for="" class="control-label">Bairro *</label>
                                <input
                                        type="text"
                                        class="form-control"
                                        :class="{ 'has-error': districtCardError }"
                                        maxlength="55"
                                        v-model="districtCard">
                                <span class="help-block" v-if="districtCardError">
                                                {{ districtCardError }}
                                            </span>
                            </div>

                            <div class="form-group col-md-5" :class="{ 'has-error': false }">
                                <label for="" class="control-label">Cidade *</label>
                                <input type="text" class="form-control" :class="{ 'has-error': cityCardError }" minlength="2" maxlength="60" v-model="cityCard">
                                <span class="help-block" v-if="cityCardError">
                                    {{ cityCardError }}
                                </span>
                            </div>

                            <div class="form-group col-md-2" :class="{ 'has-error': false }">
                                <label for="" class="control-label">UF *</label>
                                <input type="text" class="form-control" :class="{ 'has-error': stateCardError }" maxlength="2" v-model="stateCard">
                                <span class="help-block" v-if="stateCardError">
                                    {{ stateCardError }}
                                </span>
                            </div>

                        </div>

                    </div>

                    <div class=" col-md-12">

                        <button class="btn btn-md btn-gray" @click="goToStep('one')">
                            voltar
                        </button>
                        <button class="btn btn-md btn-primary" @click="processPayment">
                            {{ lastStepDescription }}
                        </button>

                    </div>

                </div>
                
            </div>

            <!-- Passo 3 -->
            <div class="ibox-content checkout">
                <div>
                    <p class="no-margins">
                        <strong>3º passo: </strong> Processando o pagamento
                    </p>
                </div>
                <div class="row" v-if="activeStep === 'three'">

                    <div class="col-md-12 text-center">
                        <div class="checkoutStatus">
                            <div class="icon processing"
                                v-if="!isFinished"></div>
                            <div class="icon finished" v-else></div>
                        </div>
                        <h3 v-if="!isFinished">Estamos processando seu pagamento</h3>
                        <h3 v-else>Processamos seu pagamento</h3>
                        <p v-if="!isFinished">
                            Isso pode levar alguns instantes. Aguarde enquanto
                            completamos a conexão com nosso gateway de pagamentos.
                        </p>
                        <p v-if="processingPayment === true">
                            <strong class="h3">Seu pagamento está em análise. Em breve você receberá um e-mail de confirmação.</strong>
                        </p>
                        <p v-if="processingPayment === false">
                            Sua compra foi finalizada com sucesso!
                        </p>
                        <p v-if="selectedPaymentMethod == 'boleto' && isFinished">
                            <strong class="h3">Click <a v-bind:href="boletoLink" target="_blank">aqui</a> para imprimir o boleto agora.</strong>
                        </p>
                        <button v-if="selectedPaymentMethod == 'boleto' && isFinished && barCode != null" 
                                    type="button"
                                    @click="copy_to_clipboard_barcode()" 
                                    :class="isCopyBarCode ? 'btn btn-gray' : 'btn btn-primary'"
                                    name="barcode_copy_and_paste" 
                                    id="barcode_copy_and_paste" 
                                    :title="isCopyBarCode ? 'Código de barras copiado com sucesso' : '' "
                                    :value=barCode>
                                    Copiar código de barras
                                    <i class="fa fa-copy"></i>
                        </button>

                        <p v-if="selectedPaymentMethod == 'pix' && isFinished">
                            <strong class="h3">Efetue a leitura do QR Code abaixo para pagar ou click no <a v-bind:href="pixQrCodeLink" target="_blank">link</a> para acessar o QR Code em tela cheia</strong>
                        </p>
                        <p v-if="selectedPaymentMethod == 'pix' && isFinished">
                            <embed v-bind:src="pixQrCodeLink" type="image/svg+xml" width="202" height="202">
                        </p>

                        <button v-if="selectedPaymentMethod == 'pix' && isFinished && pixCode != null" 
                                    type="button"
                                    @click="copy_to_clipboard()" 
                                    :class="isCopyPixCode ? 'btn btn-gray' : 'btn btn-primary'"
                                    name="pix_copy_and_paste" 
                                    id="pix_copy_and_paste" 
                                    :title="isCopyPixCode ? 'Código pix copiado com sucesso' : '' "
                                    :value=pixCode>
                                    Copiar código Pix
                                    <i class="fa fa-copy"></i>
                        </button>

                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-md-12" v-if="errorReturned">
                    <div class="alert alert-danger" role="alert">
                        <strong>Erro!</strong> {{ errorReturned }}
                    </div>
                </div>
                <div class="col-md-12" v-if="messageReturned">
                    <div class="alert alert-success" role="alert">
                        <strong>Atenção!</strong> {{ messageReturned }}
                    </div>
                </div>
                <div class="col-md-12" v-if="gatewayResponseReturned">
                    <div class="alert alert-danger" role="alert">
                        <strong>Resposta do Gateway: </strong> {{ gatewayResponseReturned }}
                    </div>
                </div>
            </div>
        
        </span>

        <div v-if="bid.bid_transaction && bid.bid_transaction.status != 7 && bid.bid_transaction.status != 6" class="ibox-content payments-method">

            <h2>Existe uma transação em andamento, se você já efetuou o pagamento, por favor, aguarde até validarmos o mesmo.</h2>
            <h3>Caso ainda não tenha efetuado o pagamento, sinta-se livre para efetuar o pagamento pelo link abaixo ou pelo email que te enviamos!</h3>

            <br>

            <h3>Dados da Transação</h3>
            <br>
            <p>
                <strong>Forma de Pagamento:</strong>
                <span v-if="bid.bid_transaction.method == 'boleto'">Boleto Bancário</span>
                <span v-if="bid.bid_transaction.method == 'pix'">Pix</span>
                <span v-if="bid.bid_transaction.method == 'creditCard'">Cartão de Crédito</span>
            </p>
            <p><strong>Data da geração do Pagamento:</strong> {{ moment(bid.bid_transaction.transaction_date).format('DD/MM/YYYY hh:mm') }}</p>
            <br>

            <div class="text-center">
                <p v-if="bid.bid_transaction.method == 'boleto'">
                    <strong class="h3">Click <a v-bind:href="bid.bid_transaction.link_payment" target="_blank">aqui</a> para imprimir o boleto agora.</strong>
                </p>
                <p v-if="bid.bid_transaction.method == 'pix'">
                    <strong class="h3">Click <a v-bind:href="bid.bid_transaction.link_payment" target="_blank">aqui</a> para acessar a tela de pagamento agora.</strong>
                </p>
                <p v-if="bid.bid_transaction.method == 'creditCard'">
                    <strong class="h3">Click <a v-bind:href="bid.bid_transaction.link_payment" target="_blank">aqui</a> para acessar a tela de pagamento agora.</strong>
                </p>
                <!--p v-if="bid.bid_transaction.method == 'pix'">
                    <embed v-bind:src="bid.bid_transaction.link_payment" type="image/svg+xml" width="202" height="202">
                </p-->
            </div>
                
        </div>

    </div>

</template>

<script>

import moment from 'moment';

export default {
    data() {
        return {
            moment: moment, 
            activeStep: 'one',
            isFinished: false,
            packages: [],
            packagesRecurrent: [],
            packagesRecurrentBought : [],
            packagesRecurrentBoughtTransaction : [],
            packagesPaymentBoght:null,
            paymentMethods:[],
            selectedPaymentMethod: null,
            selectedBank: null, 
            cardNumber: null,
            cardNumberError: null,
            cardName:null,
            cvv: null,
            cvvError: null,
            errorReturned: "",
            messageReturned: "",
            gatewayResponseReturned: "",
            expirationMonth: 12,
            expirationYear: 2030,
            expirationDateError: null,
            nameError:null,
            documentCardError:null,
            addressCard:"",
            addressCardError:null,
            complementCard:"",
            complementCardError:null,
            numberAddressCard:"",
            numberAddressCardError:null,
            districtCard:"",
            districtCardError:null,
            cityCard:"",
            cityCardError:null,
            postalCodeCard:"",
            postalCodeCardError:null,
            stateCard:"",
            stateCardError:null,
            isLoadingCEP : false,
            isLoadingInstallments : false,
            birthDate : "",
            birthDateError : null,
            lastStepDescription : "Próximo",
            boletoLink:null,
            banksForDebit:[],
            cellPhone:null,
            cellPhoneError:null,
            processingPayment:null,
            documentCard:null,
            brand:null,
            installmentCard:null,
            installments:[],
            installmentsError:null,
            paymentCardBrandError: null,
            cardBrands:[],
            pixCode:null,
            isCopyPixCode:false,
            barCode:null,
            isCopyBarCode:false,
        };
    },
    props:{
        bid: {
            type: Object,
            required: true,
        }
    },
    mounted() {

        axios.get('/financeiro/card-brands/contractor')
            .then(({data}) => {

            if(data.length != 0) {
                this.cardBrands = data;
            }
            else {
                console.error('Problemas com as brands');
            }
        });

     },
    computed: {
        months() {
            return [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ];
        },
        years() {
            let fromYear = 2018, years = [];

            for (let i = fromYear; i < fromYear + 20; i++) {
                years.push(i);
            }

            return years;
        },
    },
    methods: {
        clearErrors() {
            this.cardNumberError = null;
            this.expirationDateError = null;
            this.cvvError = null;
            this.errorReturned = null;
            this.gatewayResponseReturned = null;
            this.addressCardError = null;
            this.numberAddressCardError = null;
            this.postalCodeCardError = null;
            this.districtCardError = null;
            this.stateCardError = null;
            this.cellPhoneError = null;
            this.paymentCardBrandError = null;
        },
        goToStep(step) { 
            
            if(step == 'two')
                if(this.selectedPaymentMethod == 'boleto'){
                    
                    this.lastStepDescription = 'Gerar boleto';

                } else {
                    
                    if(this.selectedPaymentMethod == 'creditCard'){
                        
                        let parcela = []; 
                        let taxaCartao = 1.0;

                        this.installments = [];

                        for(let i = 1; i <= 10; i++){
                            
                            if ( i == 1 )
                                parcela = {'quantity' : i, 'installmentAmount' : 'R$ '+parseFloat(this.bid.approved_proposal.amount).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                            else
                                parcela = {'quantity' : i, 'installmentAmount' : 'R$ '+ (Math.round(( parseFloat(this.bid.approved_proposal.amount * taxaCartao / i) + Number.EPSILON) * 100) / 100).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                             
                            this.installments.push(parcela); 
                            
                        }

                    }
        
                    this.lastStepDescription = "Pagar";
                    
                }

            this.activeStep = step;

        },
        handleError(errors) {
            Object.keys(errors).forEach((errorCode) => {
                if (errorCode == 10000) {
                    this.cardNumberError = 'Bandeira do Cartão de crédito inválida';
                    this.errorReturned = '10000 - Bandeira do Cartão de crédito inválida';
                } else if (errorCode == 10001) {
                    this.cardNumberError = 'Número de Cartão de crédito inválido';
                    this.errorReturned = '10001 - Número de Cartão de crédito inválido';
                } else if (errorCode == 10002) {
                    this.expirationDateError = 'Validade do Cartão Inválida';
                    this.errorReturned = '10002 - Validade do Cartão Inválida';
                } else if (errorCode == 10003) {
                    this.cvvError = 'CVC Inválido';
                    this.errorReturned = '10003 - CVC Inválido';
                } else if (errorCode == 10004) {
                    this.cvvError = 'CVC Inválido';
                    this.errorReturned = '10004 - CVC Inválido';
                } else if (errorCode == 10006) {
                    this.cvvError = 'Codigo de Segurança com tamanho inválido';
                    this.errorReturned = '10006 - Codigo de Segurança com tamanho inválido';
                } else if (errorCode == 11017) {
                    this.postalCodeCardError = 'CEP Inválido';
                    this.errorReturned = '11017 - CEP Inválido';
                } else if (errorCode == 11018) {
                    this.addressCardError = 'Endereço Inválido';
                    this.errorReturned = '11018 - Endereço Inválido';
                } else if (errorCode == 11019) {
                    this.numberAddressCardError = 'Numero Inválido';
                    this.errorReturned = '11019 - Número do Endereço Inválido';
                } else if (errorCode == 11021) {
                    this.districtCardError = 'Bairro Inválido';
                    this.errorReturned = '11021 - Bairro Inválido';
                } else if (errorCode == 11022) {
                    this.cityCardError = 'Cidade Inválida';
                    this.errorReturned = '11022 - Cidade Inválida';
                } else if (errorCode == 11023) {
                    this.stateCardError = 'Estado Inválido';
                    this.errorReturned = '11023 - Estado Inválido';
                } else if (errorCode == 11157) {
                    this.documentCardError = 'CPF Inválido';
                    this.errorReturned = '11157 - CPF Inválido';
                } else if (errorCode == 30400) {
                    this.cardNumberError = 'Número de Cartão de crédito inválido';
                    this.errorReturned = '30400 - Número de Cartão de crédito inválido';
                } else if (errorCode == 53015) {
                    this.nameError = 'Nome inválido';
                    this.errorReturned = '53015 - Nome do cartão inválido';
                } else if (errorCode == 53048) {
                    this.nameError = '53048 - Data de nascimento inválida';
                    this.errorReturned = '53048 - Data de nascimento inválida';
                }
                else {
                    if (errorCode != '') {
                        this.errorReturned = errorCode + " - Houve um erro no processamento. Atualize a página e tente novamente.";
                    } else {
                        this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";
                    }
                }

            });
        },
        handleErrorAPI(errorCode, errorMessage) {
            if (errorCode == 10000) {
                this.cardNumberError = 'Bandeira do Cartão de crédito inválida';
                this.errorReturned = '10000 - Bandeira do Cartão de crédito inválida';
            } else if (errorCode == 10001) {
                this.cardNumberError = 'Número de Cartão de crédito inválido';
                this.errorReturned = '10001 - Número de Cartão de crédito inválido';
            } else if (errorCode == 10002) {
                this.expirationDateError = 'Validade do Cartão Inválida';
                this.errorReturned = '10002 - alidade do Cartão Inválida';
            } else if (errorCode == 10003) {
                this.cvvError = 'CVC Inválido';
                this.errorReturned = '10003 - CVC Inválido';
            } else if (errorCode == 10004) {
                this.cvvError = 'CVC Inválido';
                this.errorReturned = '10004 - CVC Inválido';
            } else if (errorCode == 10006) {
                this.cvvError = 'Codigo de Segurança com tamanho inválido';
                this.errorReturned = '10006 - Codigo de Segurança com tamanho inválido';
            } else if (errorCode == 11017) {
                this.postalCodeCardError = 'CEP Inválido';
                this.errorReturned = '11017 - CEP Inválido';
            } else if (errorCode == 11018) {
                this.addressCardError = 'Endereço Inválido';
                this.errorReturned = '11018 - Endereço Inválido';
            } else if (errorCode == 11019) {
                this.numberAddressCardError = 'Numero Inválido';
                this.errorReturned = '11019 - Número do Endereço Inválido';
            } else if (errorCode == 11021) {
                this.districtCardError = 'Bairro Inválido';
                this.errorReturned = '11021 - Bairro Inválido';
            } else if (errorCode == 11022) {
                this.cityCardError = 'Cidade Inválida';
                this.errorReturned = '11022 - Cidade Inválida';
            } else if (errorCode == 11023) {
                this.stateCardError = 'Estado Inválido';
                this.errorReturned = '11023 - Estado Inválido';
            } else if (errorCode == 11157) {
                this.documentCardError = 'CPF Inválido';
                this.errorReturned = '11157 - CPF Inválido';
            } else if (errorCode == 30400) {
                this.cardNumberError = 'Número de Cartão de crédito inválido';
                this.errorReturned = '30400 - Número de Cartão de crédito inválido';
            } else if (errorCode == 53048) {
                this.nameError = '53048 - Data de nascimento inválida';
                this.errorReturned = '53048 - Data de nascimento inválida';
            } else if (errorCode == 530159) {
                this.nameError = '53015 - Nome inválido';
                this.errorReturned = '53015 - Nome inválido';
            }else if (errorCode == 10008){ 
                this.cellPhoneError = "10008 - Numero de celular inválido."; 
                this.errorReturned = '10008 - Numero de celular inválido';
            }else if (errorCode == 10009){ 
                this.documentCardError = "10009 - Numero de CPF/CNPJ inválido."; 
                this.errorReturned = '10009 - Numero de CPF/CNPJ inválido';
            }else if (errorCode == 10010){ 
                this.cardNumberError = "10010 - Bandeira do cartão inválido"; 
                this.errorReturned = '10010 - Bandeira do cartão inválido';
            }else if (errorCode == 10011){ 
                this.cardNumberError = "10011 - Numero de cartão inválido"; 
                this.errorReturned = '10011 - Numero de cartão inválido';
            }else if (errorCode == 19999){ 
                this.errorReturned = '19999 - Erro nos dados informados';
            }
            else {
                if (errorCode != '' && errorMessage != '') { 
                    this.errorReturned = errorCode + ' - ' + errorMessage;
                } else {
                    this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";
                }
            }
        },
        processPayment() {
            
            this.clearErrors();

            if(this.selectedPaymentMethod == 'creditCard'){

                this.goToStep('three');
                this.clearErrors();
                this.sendPaymentCartao();

            }else if(this.selectedPaymentMethod == 'boleto')
                this.sendPaymentBoleto();

            else if(this.selectedPaymentMethod == 'pix')
                this.sendPaymentPix();

        },
        sendPaymentPix() { 

            if(this.validateForm()){ 
                    
                this.goToStep('three');
                this.clearErrors();

                var data = { 
                    bid_id: this.bid.id,
                    amount: this.bid.approved_proposal.amount,
                    installments: 1,
                    paymentMethod:this.selectedPaymentMethod,
                    address:this.addressCard,
                    addressNumber:this.numberAddressCard,
                    state:this.stateCard,
                    district:this.districtCard,
                    postalCode:this.postalCodeCard,
                    city:this.cityCard,
                    bankName:this.selectedBank,
                    mobile_phone:this.cellPhone,
                    document:this.documentCard,
                };

                axios.post('/financeiro/checkout/bid', data).then((result) => {
                    
                    if(!result.data.success){

                        this.goToStep('two');
                        this.handleErrorAPI(result.data.errorCode, result.data.errorMessage);
                        
                    } else {

                        this.pixLink = result.data.payment_link;
                        this.pixCode = result.data.pix_code;
                        this.pixQrCodeLink = result.data.qrcode;
                        this.isFinished = true;
                        this.errorReturned = null;

                    }

                }).catch(() => {

                    this.goToStep('two');
                    this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";

                }) 
                
            }

        }, 
        sendPaymentBoleto() {

            if(this.validateForm()){ 

                this.goToStep('three');
                this.clearErrors();

                var config = { 
                    bid_id: this.bid.id,
                    amount: this.bid.approved_proposal.amount,
                    installments: 1,
                    paymentMethod:this.selectedPaymentMethod,
                    address:this.addressCard,
                    addressNumber:this.numberAddressCard,
                    state:this.stateCard,
                    district:this.districtCard,
                    postalCode:this.postalCodeCard,
                    city:this.cityCard,
                    bankName:this.selectedBank,
                    mobile_phone:this.cellPhone,
                    document:this.documentCard,
                };

                axios.post('/financeiro/checkout/bid', config).then((result) => {

                    if(!result.data.success){

                        this.goToStep('two');
                        this.handleErrorAPI(result.data.errorCode, result.data.errorMessage);
                        
                    } else {

                        this.boletoLink = result.data.url_boleto;
                        this.barCode = result.data.barcode;
                        this.isFinished = true;
                        this.errorReturned = null;

                    }

                }).catch(() => {

                    this.goToStep('two');
                    this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";

                })

            }

        }, 
        sendPaymentCartao() {
            
            if(this.validateForm()){

                axios.get('/financeiro/card-brands/contractor').then(({data}) => {

                    if(data.length == 0){
            
                        this.goToStep('two');
                        this.errorReturned = "Houve um erro no processamento. Tente novamente.";

                        return false;

                    }
  
                    axios.post('/financeiro/checkout/bid', { 
                        bid_id: this.bid.id,
                        amount: this.bid.approved_proposal.amount,
                        installments: this.installmentCard.quantity,
                        paymentMethod      : this.selectedPaymentMethod,
                        address            : this.addressCard,
                        addressNumber      : this.numberAddressCard,
                        state              : this.stateCard,
                        district           : this.districtCard,
                        postalCode         : this.postalCodeCard,
                        city               : this.cityCard,
                        birthday           : this.birthDate,
                        mobile_phone       : this.cellPhone,
                        cardName           : this.cardName,
                        document           : this.documentCard,
                        cardNumber         : this.cardNumber,
                        cvv                : this.cvv,
                        expirationMonth    : this.expirationMonth,
                        expirationYear     : this.expirationYear,
                        cardBrand          : this.paymentCardBrand
                    }).then((result) => {

                        if(!result.data.success){

                            this.goToStep('two');
                            this.errorReturned = result.data.error;
                            this.handleErrorAPI(result.data.errorCode, result.data.errorMessage);

                            if(result.data.gatewayResponse)
                                this.gatewayResponseReturned = result.data.gatewayResponse;
                            else
                                this.gatewayResponseReturned = null;

                        } else {

                            if(result.data.gatewayResponse)
                                this.gatewayResponseReturned = result.data.gatewayResponse;
                            else
                                this.gatewayResponseReturned = null;

                            if(result.data.message)
                                this.messageReturned = result.data.message;
                            else
                                this.messageReturned = null;

                            this.isFinished = true;
                            this.processingPayment = true;

                            this.errorReturned = null;

                        }   
                        
                    }).catch(() => {

                        console.log('erro checkout');
                        this.goToStep('two');
                        this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";

                    })
                    
                }).catch(() => {

                    console.log('erro card-brands');
                    this.goToStep('two');
                    this.errorReturned = "Houve um erro no processamento. Atualize a página e tente novamente.";

                    return false;

                })

            }else{
                
                this.goToStep('two');
                this.errorReturned = "Preencha todos os campos!"; 

            }

        },
        validateForm(){
            
            if(this.selectedPaymentMethod == 'creditCard'){
                if (!this.cardName){
                    this.nameError = "Informe o nome extamente como está no cartão";
                    return false;
                } else {
                    this.nameError = null;
                }

                if (!this.documentCard){
                    this.documentCardError = "Informe o número do documento. Ex. CPF";
                    return false;
                } else {
                    this.documentCardError = null;
                }

                if (this.documentCard.length != 11) {
                    this.documentCardError = "O CPF deve ter 11 dígitos numéricos";
                    return false;
                } else {
                    this.documentCardError = null;
                }

                if (!this.documentCard.match('[0-9]{11}')) {
                    this.documentCardError = "O CPF deve conter somente números";
                    return false;
                } else {
                    this.documentCardError = null;
                }

                if (!this.birthDate){
                    this.birthDateError = "Informe a data de nascimento";
                    return false;
                } else {
                    this.birthDateError = null;
                }

                if (!this.paymentCardBrand){
                    this.paymentCardBrandError = "Informe a bandeira do cartão";
                    return false;
                } else {
                    this.paymentCardBrandError = null;
                }
                
                if (!this.cardNumber){
                    this.cardNumberError = "Informe o número do cartão";
                    return false;
                } else {
                    this.cardNumberError = null;
                }

                if (!this.cvv){
                    this.cvvError = "Informe o código de segurança";
                    return false;
                } else {
                    this.cvvError = null;
                }

            }
            // boletos
            if(this.selectedPaymentMethod == 'boleto' || this.selectedPaymentMethod == 'pix' ) {
                if ( (this.documentCard.length != 11) && (this.documentCard.length != 14) ) {
                    this.documentCardError = "O CPF deve ter 11 dígitos numéricos e o CNPJ 14 dígitos numéricos";
                    return false;
                } else {
                    this.documentCardError = null;
                }

                if (!this.documentCard.match('[0-9]{11,14}')) {
                    this.documentCardError = "O CPF/CNPJ deve conter somente números";
                    return false;
                } else {
                    this.documentCardError = null;
                }
            }

            if (!this.cellPhone){
                this.cellPhoneError = "Informe o número do celular. Deve ter 11 dígitos";
                return false;
            } else {
                this.cellPhoneError = null;
            }

            if(!this.cellPhone.match('[0-9]{10,11}')){
                this.cellPhoneError = "Informar somente números, incluindo o DDD com dois dígitos";
                return false
            } else {
                this.cellPhoneError = null;
            }

            if (!this.postalCodeCard){
                this.postalCodeCardError = "Informe o CEP";
                return false;
            } else {
                this.postalCodeCardError = null;
            }

            if(!this.postalCodeCard.match('[0-9]{8}')){
                this.postalCodeCardError = "CEP incorreto. Deve conter somente 8 caracteres, não precisa do '-'.";
                return false
            } else {
                this.postalCodeCardError = null;
            }

            if (!this.addressCard){
                this.addressCardError = "Informe o endereço";
                return false;
            } else {
                this.addressCardError = null;
            }

            if (!this.numberAddressCard){
                this.numberAddressCardError = "Informe o número do endereço";
                return false;
            } else {
                this.numberAddressCardError = null;
            }


            if (!this.districtCard){
                this.districtCardError = "Informe o bairro";
                return false;
            } else {
                this.districtCardError = null;
            }

            if (!this.cityCard){
                this.cityCardError = "Informe a cidade";
                return false;
            } else {
                this.cityCardError = null;
            }

            if (!this.stateCard){
                this.stateCardError = "Informe a Unidade Federativa (Estado)";
                return false;
            } else {
                this.stateCardError = null;
            }

            return true;
        },
        validatePostalCode(){
            this.isLoadingCEP = true;
            axios.get('/cep/search/contractor/'+this.postalCodeCard)
                .then((response) => {
                    console.log(response);
                    this.isLoadingCEP = false;
                    if(response.status == 200){
                        var result = response.data;
                        if(result.erro == undefined){
                            this.addressCard = result.logradouro;
                            this.districtCard = result.bairro;
                            this.cityCard = result.localidade;
                            this.stateCard = result.uf;
                            this.$refs.numberAddressCardError.focus();
                            this.postalCodeCardError = null;
                        } else {
                            this.addressCard = null;
                            this.districtCard = null;
                            this.cityCard = null;
                            this.stateCard = null;
                            this.numberAddressCard = null;
                            this.postalCodeCardError = "CEP não encontrado";
                        }
                    } else {
                        this.addressCard = null;
                        this.districtCard = null;
                        this.cityCard = null;
                        this.stateCard = null;
                        this.numberAddressCard = null;
                        this.postalCodeCardError = "CEP incorreto";
                    }
                })
                .catch((error) => {
                    this.addressCard = null;
                    this.districtCard = null;
                    this.cityCard = null;
                    this.stateCard = null;
                    this.isLoadingCEP = false;
                    this.numberAddressCard = null;
                    this.postalCodeCardError = "CEP incorreto";
                });
        },
        copy_to_clipboard( ) 
        {
            var text = document.getElementById("pix_copy_and_paste");
            navigator.clipboard.writeText( text.value );
            this.isCopyPixCode = true;
        },
        copy_to_clipboard_barcode( ) 
        {
            var text = document.getElementById("barcode_copy_and_paste");
            navigator.clipboard.writeText( text.value );
            this.isCopyBarCode = true;
        }
    }
}
</script>